module.exports = __webpack_public_path__ + "img/op_fondo-cta-empresas-tablet.d1fa553.jpg";